import React, { Component } from 'react'

import { Subsections } from './'

class VideoBG extends Component {
    render() {
        const { videoUrl, colorOverlay, sections } = this.props.data

        return (
            <div className="video-bg-section">
                {colorOverlay && <div className="video-bg-overlay" />}
                <video autoPlay loop className="video-background" muted plays-inline="true">
                    <source src={videoUrl} type="video/mp4" />
                </video>
                <div className="video-bg-content">
                    <div className="container align-items-center">
                        <div className="slider-content align-self-center text-white p-5">
                            <Subsections subsections={sections} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export { VideoBG }


// WEBPACK FOOTER //
// ./src/components/sections/VideoBG.js